import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 15.46l-5.27-.61-2.52 2.52c-2.83-1.44-5.15-3.75-6.59-6.59l2.53-2.53L8.54 3H3.03C2.45 13.18 10.82 21.55 21 20.97v-5.51z"
}), 'LocalPhoneSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalPhoneSharp.js
// module id = 4634
// module chunks = 2